export default "__VITE_ASSET__DErU4mWJ__"